import { useState } from "react";
import pennDotLogo from "./images/logo/pennDotLogo.png";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { GREY_1, PENN_DOT_BLUE } from "../constants/styleConstants";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routesConstants";

export const NAVBAR_HEIGHT = "65";

export default function Navbar({ icon }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const navigateTo = (route) => {
    navigate(route);
    handleClose();
  };

  return (
    <div
      data-testid="navbar"
      style={{
        width: "100%",
        height: `${NAVBAR_HEIGHT}px`,
        borderBottom: "solid",
        borderBottomWidth: "2px",
        borderBottomColor: GREY_1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <IconButton
          id="basic-icon"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <DensityMediumIcon />
        </IconButton>
        <Menu
          style={{ color: PENN_DOT_BLUE }}
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => navigateTo(ROUTES.ABOUT)}>About</MenuItem>
          <MenuItem onClick={() => navigateTo(ROUTES.CONTACT)}>
            Contact
          </MenuItem>
          <MenuItem onClick={() => navigateTo(ROUTES.DISCLAIMER)}>
            Disclaimer
          </MenuItem>
        </Menu>
        <Link style={{ textDecoration: "none" }} to={ROUTES.HOMEPAGE}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={pennDotLogo}
              alt="PennDOT logo"
              style={{
                marginLeft: "20px",
                height: "34px",
              }}
            />
            <h1
              style={{
                margin: "20px 0 20px 15px",
                color: PENN_DOT_BLUE,
                fontSize: "24px",
                fontFamily: "sans-serif",
              }}
            >
              PennDOT ICE
            </h1>
          </div>
        </Link>
      </div>
      {icon}
    </div>
  );
}
